import React, { Component } from "react";
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { connect } from "react-redux";
import FaTrash from "react-icons/lib/fa/trash";
import FaTimesCircleO from "react-icons/lib/fa/times-circle-o";
import FaUserPlus from "react-icons/lib/fa/user-plus";

import {
  fetchCalendarEntriesForUser,
  createEntryForUser,
  tagUsersForEntry,
  deleteCalendarEntry
} from "../../../actions/calendar-entries.js";
import { fetchUsers } from "../../../actions/user.js";
import { messageOnSend } from '../../../actions/chat/messageActions.js';

import Col from "../../../common/grid/Col.js";
import Button from "../../../common/button/Button.js";
import Input from "../../../common/input/Input.js";
import CheckboxContainer from "../../../common/checkbox/CheckboxContainer.js";

// Css for calendar
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

BigCalendar.momentLocalizer(moment);

class UserCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "month",
      selectedDate: new Date(),
      showInputModal: false,
      showTagUsersModal: false,
      currentEntryId: null,
      currentEntryTitle: null,
      selectedEntry: null,
      newEntry: null,
      users: [],
      taggableUsers: []
    };
  }

  /**
   * Change handler for input value
   */
  onModalInputChange = (value) => {
    this.setState({ currentEntryTitle: value })
  }

  /**
   * Handle modal save
   */
  onModalSaveClick = () => {
    let newEntry = this.state.newEntry;
    newEntry['title'] = this.state.currentEntryTitle;
    newEntry['users'] = this.state.users;

    this.props.createEntryForUser(this.props.user.id, newEntry);

    this.setState({
      newEntry: null,
      showInputModal: false,
      currentEntryId: null,
      currentEntryTitle: null,
      selectedEntry: null,
      users: []
    });
  }

  /**
   * Handle modal cancel
   */
  onModalCancelClick = () => {
    this.setState({
      showInputModal: false,
      showTagUsersModal: false,
      currentEntryId: null,
      currentEntryTitle: null,
      newEntry: null,
      updated: false,
      users: []
    });
  }

  /**
   * Handle click event of Delete selection button
   */
  onDeleteSelectionClick = () => {
    this.props.deleteCalendarEntry(this.props.user.id, this.state.selectedEntry.id);
    alert("Event has been deleted!");
    this.cancelSelection(); // resets state (hides buttons)
  }

  /**
   * Cancel event selection
   */
  cancelSelection = () => this.setState({ selectedEntry: null })

  /**
   * Handle Calendar's slot select event
   */
  onCalendarSlotSelect = slotInfo => {
    // Check the difference between start & end
    // Go to day view if < 24hours and current view is not already day
    let start = moment(slotInfo.start);
    let end = moment(slotInfo.end);

    if ((end.diff(start, 'hours')) < 24 && (this.state.view !== 'day')) {
      this.setState({
        view: 'day',
        selectedDate: start.toDate()
      });
    } else if (end.diff(start, 'hours') >= 24 && (this.state.view !== 'week')) {
      // Go to week view if >= 24hours and current view is not already week
      this.setState({
        view: 'week',
        selectedDate: start.toDate()
      });
    } else {
      this.setState({
        newEntry: {
          id: this.props.userEntries.length - 1,
          start: moment(slotInfo.start).format('YYYY-MM-DD HH:mm:ss').toString(),
          end: moment(slotInfo.end).format('YYYY-MM-DD HH:mm:ss').toString(),
          title: ''
        },
        showInputModal: true
      });
    }
  }

  /**
   * Handle calendar's event select event
   */
  onCalendarEventSelect = e => this.setState({ selectedEntry: e })

  /**
   * Change handler for checkboxes
   * @param {any} value 
   * @param {string} name 
   */
  onCheckboxChange = (value, name) => {
    const arr = this.state[name];

    // check if state[name] has value
    if (arr.includes(value)) {
      arr.splice(arr.indexOf(value), 1);
      this.setState({ [name]: arr });
    } else {
      this.setState({ [name]: arr.concat(value) });
    }
  }

  /**
   * Click handler for tag users button
   */
  onTagUsersAtSelectionClick = () => {
    const usersOfCurrentEntry = this.state.selectedEntry.users.map(u => u.id);
    this.setState({
      showTagUsersModal: true,
      users: usersOfCurrentEntry
    });
  }

  /**
   * Event handler for tag users modal's save button
   */
  onTagUsersModalSave = () => {
    this.props.tagUsersForEntry(this.state.selectedEntry.id, this.state.users);

    // iterate over users and send chat notifications
    for (const userId of this.state.users) {
      this.props.messageOnSend({
        to: userId,
        seen: false,
        type: 'calendar',
        eventId: this.state.selectedEntry.id,
        message: `You've been tagged in an event! Click here to jump to calendar!`,
        latestTime: new Date()
      });
    }

    this.setState({
      newEntry: null,
      showInputModal: false,
      showTagUsersModal: false,
      currentEntryId: null,
      currentEntryTitle: null,
      selectedEntry: null,
      users: []
    });
  }

  /**
   * Render tag users modal
   */
  _renderTagUsersModal = () => {
    const checkAgainst = this.state.users.map(u => ({ value: u }));

    return (
      <Col _bottom-32 dialog>
        <Col _bottom-8>
          <hr />
          <div className="user-selector">
            <CheckboxContainer
              title='Select users to tag'
              name='users'
              onCheckboxChange={this.onCheckboxChange}
              checkboxData={this.state.taggableUsers}
              checkAgainst={checkAgainst}
            />
          </div>
        </Col>
        <div className="dialog-buttons">
          <Button className="btn-plain" onClick={this.onTagUsersModalSave}>SAVE</Button>
          <Button className="btn-plain" onClick={this.onModalCancelClick}>CANCEL</Button>
        </div>
      </Col>
    );
  }

  /**
   * Render new entry modal
   */
  _renderCommentInputModal = () => {
    const checkAgainst = this.state.users.map(u => ({ value: u }));

    return (
      <Col _bottom-32 dialog>
        <Col _bottom-8>
          <span>Please, enter a comment</span>
          <Input
            ph="Comment"
            type="text"
            onChange={this.onModalInputChange}
          />
          <hr />
          <div className="user-selector">
            <CheckboxContainer
              title='Select users to tag'
              name='users'
              onCheckboxChange={this.onCheckboxChange}
              checkboxData={this.state.taggableUsers}
              checkAgainst={checkAgainst}
            />
          </div>
        </Col>
        <div className="dialog-buttons">
          <Button className="btn-plain" onClick={this.onModalSaveClick}>SAVE</Button>
          <Button className="btn-plain" onClick={this.onModalCancelClick}>CANCEL</Button>
        </div>
      </Col>
    );
  }


  componentDidMount() {
    this.props.fetchCalendarEntriesForUser(this.props.user.id);
    this.props.fetchUsers();


  }

  componentWillReceiveProps(nextProps) {
    // Omit current user
    // This is to disallow selftagging on events
    if (nextProps.users.length > 0) {
      const taggableUsers = [];

      for (const user of this.props.users) {
        if (user.id !== this.props.user.id) {
          taggableUsers.push({
            display_name: user.first_name + " " + user.last_name,
            value: user.id,
            thumbnail: user.profile_photo_url
          })
        }
      }

      this.setState({ taggableUsers });
    }

    if (nextProps.userEntries.length > 0) {

      const { match } = nextProps;

      // Check for eventId (after navigation)
      if ((match.params.entryId && !this.state.selectedEntry) || (match.params.entryId && (this.state.selectedEntry.id !== match.params.entryId))) {
        const selectedEntry = nextProps.userEntries.filter(e => e.id !== match.params.entryId)[0];
        // console.log(this.props.userEntries)
        this.setState({ selectedEntry, selectedDate: new Date(selectedEntry.start), view: 'day' });
      }
    }
  }

  render() {
    const { userEntries, user } = this.props;
    const { selectedEntry } = this.state;
    const isCurrentUserAuthor = !!(selectedEntry && selectedEntry.user.id === user.id);
    return (
      <div className="user-calendar" style={{ height: '100vh' }}>
        {selectedEntry && (
          <div className="buttons">
            {isCurrentUserAuthor && <Button className="btn-yellow btn-square" onClick={this.onTagUsersAtSelectionClick}><FaUserPlus /> Tag User(s)</Button>}
            {isCurrentUserAuthor && <Button className="btn-red btn-square" onClick={this.onDeleteSelectionClick}><FaTrash /> Delete Selected Entry</Button>}
            <Button className="btn-square" onClick={this.cancelSelection}><FaTimesCircleO /> Cancel Selection</Button>
          </div>
        )}
        {this.state.showInputModal && this._renderCommentInputModal()}
        {this.state.showTagUsersModal && this._renderTagUsersModal()}
        <BigCalendar
          selectable
          defaultDate={this.state.selectedDate}
          date={this.state.selectedDate}
          onNavigate={(day) => this.setState({ selectedDate: new Date(day) })}
          events={userEntries}
          views={['month', 'week', 'day']}
          view={this.state.view}
          startAccessor={(e) => new Date(e.start)}
          endAccessor={(e) => new Date(e.end)}
          min={moment().hour(7).minute(0).second(0).toDate()}
          max={moment().hour(23).minute(0).second(0).toDate()}
          onView={view => this.setState({ view })}
          onSelectSlot={this.onCalendarSlotSelect}
          onSelectEvent={this.onCalendarEventSelect}
          selected={this.state.selectedEntry}
          titleAccessor={(e) => {
            const taggedUsers = e.users.map(u => `${u.first_name} ${u.last_name}`).join(', ');

            return `Event: ${e.title} | Added by: ${e.user.first_name} ${e.user.last_name} | Participants: ${taggedUsers}`;
          }}

        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.currentUser,
    userEntries: state.calendarEntry.user,
    users: state.user.allUsers
  };
};

const mapDispatchToProps = {
  fetchUsers,
  fetchCalendarEntriesForUser,
  createEntryForUser,
  tagUsersForEntry,
  deleteCalendarEntry,
  messageOnSend
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCalendar);



// WEBPACK FOOTER //
// ./src/components/main/calendar/_userCalendar.js